<p-tabs value="0">
  <p-tablist>
    <p-tab value="0">登録</p-tab>
    <p-tab value="1">一括削除</p-tab>
  </p-tablist>
  <p-tabpanels>
    <!-- 登録タブ -->
    <p-tabpanel value="0">
      <div class="container">
        <!-- 入力画面 -->
        @if (viewState === 'input') {
          <div>
            <p>KeepaからエクスポートしたTSVデータを貼り付けてください。</p>
            <textarea
              pInputTextarea
              [(ngModel)]="tsvText"
              [rows]="12"
              class="tsv-textarea"
              placeholder="Keepa TSVデータを貼り付け"></textarea>
            <div class="action-row">
              <p-button
                label="取り込み対象を確認"
                icon="pi pi-search"
                [disabled]="!tsvText.trim()"
                (click)="onParse()"></p-button>
              <div class="tsv-download-group">
                <p-button
                  label="前月実績TSVダウンロード"
                  icon="pi pi-download"
                  styleClass="p-button-outlined"
                  [loading]="downloading"
                  (click)="onDownloadTsv()"></p-button>
                <p-checkbox
                  [(ngModel)]="onlyMissingKeepa"
                  [binary]="true"
                  inputId="onlyMissingKeepa"></p-checkbox>
                <label for="onlyMissingKeepa">Keepa月間販売個数が未登録のデータのみ出力</label>
              </div>
            </div>
          </div>
        }

        <!-- プレビュー画面 -->
        @if (viewState === 'preview') {
          <div>
            @if (parseErrorCount > 0) {
              <p-message severity="warn">{{ parseErrorCount }}件の行がパースエラーのためスキップされました</p-message>
            }
            <p class="preview-summary">{{ previewRows.length }}件の商品を登録します</p>
            <p-table
              [value]="previewRows"
              [rows]="50"
              [paginator]="previewRows.length > 50"
              class="p-datatable-sm p-datatable-striped">
              <ng-template #header>
                <tr>
                  <th style="width: 40px">#</th>
                  <th style="width: 120px">ASIN</th>
                  <th style="width: 100px">先月の購入</th>
                  <th>カテゴリ</th>
                </tr>
              </ng-template>
              <ng-template
                #body
                let-row
                let-rowIndex="rowIndex">
                <tr>
                  <td class="text-center">{{ rowIndex + 1 }}</td>
                  <td>{{ row.asin }}</td>
                  <td class="text-right">{{ row.boughtPastMonth < 10 ? '9以下' : (row.boughtPastMonth | number) }}</td>
                  <td>{{ row.categoryNames.join(', ') }}</td>
                </tr>
              </ng-template>
            </p-table>
            <div class="action-row">
              <p-button
                label="戻る"
                icon="pi pi-arrow-left"
                styleClass="p-button-text"
                (click)="onBack()"></p-button>
              <p-button
                label="登録"
                icon="pi pi-check"
                (click)="onSubmit()"></p-button>
            </div>
          </div>
        }

        <!-- 送信中 -->
        @if (viewState === 'submitting') {
          <div class="center">
            <p-progressspinner></p-progressspinner>
            <p>登録中...</p>
          </div>
        }

        <!-- 完了画面 -->
        @if (viewState === 'done') {
          <div>
            <p-message [severity]="resultSeverity">{{ resultMessage }}</p-message>
            <div class="action-row">
              <p-button
                label="続けて登録"
                icon="pi pi-refresh"
                (click)="onReset()"></p-button>
            </div>
          </div>
        }
      </div>
    </p-tabpanel>

    <!-- 削除タブ -->
    <p-tabpanel value="1">
      <div class="container">
        <p>削除したいAmazon商品のASINを改行区切りで入力してください。</p>
        <textarea
          pInputTextarea
          [(ngModel)]="deleteAsinsText"
          [rows]="12"
          class="tsv-textarea"
          placeholder="ASINを改行区切りで入力"></textarea>
        <div class="action-row">
          <p-button
            label="削除"
            icon="pi pi-trash"
            severity="danger"
            [disabled]="!deleteAsinsText.trim() || deleting"
            [loading]="deleting"
            (click)="onDeleteConfirm()"></p-button>
        </div>

        @if (deleteShowResult) {
          <div class="delete-result">
            <p-message [severity]="deleteResultSeverity">{{ deleteResultMessage }}</p-message>
            <div class="action-row">
              <p-button
                label="続けて削除"
                icon="pi pi-refresh"
                (click)="onDeleteReset()"></p-button>
            </div>
          </div>
        }
      </div>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>

<p-confirmdialog></p-confirmdialog>
